import React from 'react';
import ReportingGiftCardsPage from '../components/ReportingGiftCardsPage';

const ReportingGiftCardsApp = (props) => (
  <ReportingGiftCardsPage {...props} />
);

export default ReportingGiftCardsApp;
